import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/customerDetails'
import Component from 'components/CustomerDetails'

export default createListViewContainer({ actions, selectors: selectors.customerDetails })(Component)
